
import React from "react";
import { Button, Modal } from "react-bootstrap";
import { COLORS } from "utils/colors";

/**
 * A reusable confirmation modal dialog component.
 * Displays a modal with optional title, message, and Confirm/Close buttons.
 * @memberof module:components/modals
 * @param {Object} props - Component props.
 * @param {boolean} props.show - Controls visibility of the modal.
 * @param {string} [props.title] - Optional title text for the modal header.
 * @param {React.ReactNode} props.message - Message or content to display in the modal body.
 * @param {function(): void} props.onConfirm - Callback fired when the Confirm button is clicked.
 * @param {string} [props.type] - Optional type (not currently used, but can be used to customize style or behavior).
 * @param {function():  void} props.onClose - Callback fired to close/hide the modal.
 * 
 * @returns {JSX.Element} The confirmation modal component.
 */
const ConfirmationModal = ({
  show,
  title,
  message,
  onConfirm,
  type,
  onClose,
}) => {
  const modalStyle = {
    backgroundColor: COLORS.darkGrey,
    border: `1px solid ${COLORS.blue}`,
    color: COLORS.greyFontColor,
  };

  return (
    <Modal show={show} onHide={onClose}>
      {title && (
        <Modal.Header style={{ ...modalStyle, borderBottom: 0 }}>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
      )}
      <Modal.Body style={{ ...modalStyle, borderTop: 0, borderBottom: 0 }}>
        {message}
      </Modal.Body>
      <Modal.Footer style={{ ...modalStyle, borderTop: 0 }}>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
        <Button
          variant="primary"
          onClick={(e) => {
            onClose();
            onConfirm();
          }}
        >
          Confirm
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;
